import { Dialog } from "@progress/kendo-react-dialogs";
import ActionForm from "../ActionForm/ActionForm";
import { useSelectedPage } from "../../../../Hooks/Display/usePages";
import { useSelectedComponent } from "../../../../Hooks/Display/useComponents";
import { useActions } from "../../../../Hooks/Display/useComponentProperties";
import { uuidv4 } from "../../../../Hooks/Display/utils";
import { WORKFLOW_ACTION } from "../ActionForm/constants";

function CreateActionDialog() {

    const [actionsState, dispatch] = useActions();

    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    
    async function createNewAction(event, action) {
        const parentId = actionsState.newActionParentId || selectedComponent.id;
        const newAction = {
            ...action,
            parentId,
            pageId: selectedPage._id,
            show: true,
            id: uuidv4()
        }
        if (action.actionDisplay === "Button Group") {
            newAction.actions = [];
        } else if (action.actionType === WORKFLOW_ACTION) {
            newAction.needConfirmation = false;
            newAction.confirmationMessage = "";
        }
        dispatch.addNewAction(newAction);
        dispatch.toggleCreateActionDialog();
    }

    return (
        <Dialog
            title="Create Action"
            width={450}
            onClose={dispatch.toggleCreateActionDialog}
        >
            <ActionForm
                submitButtonText={"Add to grid"}
                onSubmit={createNewAction}
                onCancel={dispatch.toggleCreateActionDialog} />
        </Dialog>
    )
}

export default CreateActionDialog;